const getModuleState = state => state.attachedFile;

export const getTotalGeneralAttachedFiles = state =>
    getModuleState(state).totalGeneralAttachedFiles;

export const getAllFileFormat = state =>
    getModuleState(state).allFileFormat;

export const getChangesOnJSONAdministrativeDivisions = state =>
    getModuleState(state).changesOnJSONAdministrativeDivisions;